import Home from "./screens/Home";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
import Login from "./screens/Login";
// import '../node_modules/bootsrap-dark-5/dist/css/bootsrap-dark.min.css';

import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import Signup from "./screens/Signup";
import { CartProvider } from "./components/Contextreducer";
import MyOrder from "./screens/MyOrder";
function App() {
  return (
    <CartProvider>
  <Router>
<div>
  <Routes>
    <Route exact path="/" element={<Home/>} />
    <Route exact path="/login" element={<Login/>} />
    <Route exact path="/createuser" element={<Signup/>} />
    <Route exact path="/myOrder" element={<MyOrder/>} />
  </Routes>
  </div>
    </Router>

    </CartProvider>
  
  );
}

export default App;
